import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Text } from '@frontend/design-system';

export const CreditUsageLabel = ({
  aiCallCreditUsed,
}: {
  aiCallCreditUsed: 'used' | 'notUsed' | 'out' | undefined;
}) => {
  const { t } = useTranslation('calls');
  let content = <span>-</span>;

  if (aiCallCreditUsed === 'out') {
    content = (
      <>
        <Icon name='error-filled' /> <Text size='medium'>{t('Out of credits')}</Text>
      </>
    );
  } else if (aiCallCreditUsed === 'used') {
    content = (
      <>
        <Icon name='ai-credit-filled' color='success' /> <Text size='medium'>{t('Used')}</Text>
      </>
    );
  } else if (aiCallCreditUsed === 'notUsed') {
    content = (
      <>
        <Icon name='ai-credit-outline' /> <Text size='medium'>{t('Not used')}</Text>
      </>
    );
  }

  return (
    <div
      css={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        alignItems: 'center',
        justifyItems: 'start',
        gap: 'var(--fabric-space-gap-xs)',
      }}
    >
      {content}
    </div>
  );
};
